define(['jquery', 'c21/maps/TooltipManager', 'c21/lazy', 'c21/track', 'c21/results'], function () {
   "use strict";

   return function (map) {
      var self = this,

         $ = require('jquery'),
         lazy = require('c21/lazy'),
         track = require('c21/track'),
         TooltipManager = require('c21/maps/TooltipManager'),
         results = require('c21/results'),
         
         m_iPinHeight = 60,
         m_iTooltipPadding = 20,
         m_iYOffset = -m_iPinHeight - m_iTooltipPadding,

         m_map = map,
         m_jHoverTemplate = $("<div class='hoverOverlay agentSummaryHoverOverlay'><div class='contentTip'></div></div>"),
         m_jClickTemplate = $("<div class='clickOverlay agentsSearchMapOverlay agentSummaryClickOverlay'><div class='contentTip'></div></div>"),
         m_stopClick = false,
         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            clickTemplate: m_jClickTemplate,
            initClickTooltip: function (jTemplate, pinData) {
               var jRows = jTemplate.find(".agentRow");
               jRows.on({
                  mouseenter: function () {
                     track.doEvent('Mapping', 'Hover over an agent in the office');
                     var jAgentRow = $(this);
                     jAgentRow.addClass('hover');
                     $("#agent" + jAgentRow.attr('agentId')).find(".CenterLaneCard,.centerLaneCard").addClass('cardHover');
                  },
                  mouseleave: function () {
                     var jAgentRow = $(this);
                     jAgentRow.removeClass('hover');
                     $("#agent" + jAgentRow.attr('agentId')).find(".CenterLaneCard,.centerLaneCard").removeClass('cardHover');
                  },
                  click: function () {
                     if (m_stopClick) {
                        return;
                     }

                     m_stopClick = true;
                     document.location.href = $(this).find("a").eq(0).click().attr("href");
                  }
               });

               m_jClickTemplate.find(".mapToolTipClose").click(m_tooltipManager.hideClickTooltip);

               // Load the agent images
               lazy.load();
            },
            getClickHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  results.getAgentSearchListForOffice(null, pinData.getId(), function () {
                     var strHtml = $("#agentsSearchMapOverlay").html();
                     dfd.resolve(strHtml);
                  });
               }).promise();
            },
            getHoverHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strPid = pinData.getId(),
                     strId = "#agentsSearchMapHoverState_" + strPid,
                     strHtml = $(strId).html();

                  dfd.resolve(strHtml);
               }).promise();
            },
            hoverOffset: {
               x: 0,
               y: m_iYOffset,
               tip: 6
            },
            clickOffset: {
               x: 0,
               y: m_iYOffset,
               tip: 5
            }
         }),
         initialize = function () {};

      self.showClickTooltip = m_tooltipManager.showClickTooltip;
      self.showHoverTooltip = m_tooltipManager.showHoverTooltip;
      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.clear = m_tooltipManager.clear;

      initialize();
   };
});
